// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@flip/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@flip/XDL/Utilities";
import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { css } from "styled-components";

filterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        css: css`
            padding: 20px 25px;
        `,
    }),
    gap: 10,
};
filterStyles.headingItem = {
    css: css`
        display: none;
    `,
};

filterStyles.heading = {
    variant: "h5",
    as: "h2",
    css: css`
        margin: 0;
    `,
};
filterStyles.shipToGridItem = {
    width: [12, 12, 6, 6, 4],
    css: css`
        align-items: flex-end;
    `,
};
filterStyles.invoiceNumberGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        align-items: flex-end;
    `,
};
filterStyles.orderNumberGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        align-items: flex-end;
    `,
};
filterStyles.poNumberGridItem = {
    width: [12, 12, 3, 3, 2],
    css: css`
        align-items: flex-end;
    `,
};
filterStyles.fromGridItem = {
    width: [12, 6, 3, 3, 2],
    css: css`
        align-items: flex-end;
        & > div {
            width: 100%;
        }
    `,
};
filterStyles.toGridItem = {
    width: [12, 6, 3, 3, 2],
    css: css`
        align-items: flex-end;
        & > div {
            width: 100%;
        }
    `,
};
filterStyles.onlyOpenGridItem = {
    width: 12,
    align: "bottom",
};

filterStyles.buttonsItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};
filterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};
filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};
filterStyles.fromDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};
